import { Component, OnInit } from '@angular/core';
import { AuthFacade } from './+store/auth/auth.facade';

@Component({
  selector: 'my-health-admin-root',
  template: `<router-outlet></router-outlet>`,
  styles: []
})
export class AppComponent implements OnInit {
  constructor(private authFacade: AuthFacade) {}

  ngOnInit() {
    this.authFacade.validateAuth();
  }
}
